import { AxiosError } from 'axios';
import { api } from '@/Data/api';
import ss from '../Session';
import {
    QuestionnaireType,
    QuestionnaireResponse,
    TopikResponse,
    TopikListResponse
} from './types';

/**
 * Get TOPIK questionnaire with full exam content
 * @param params Object with either examid or questionnaireid, and optional section
 * @returns Promise with questionnaire data or null if failed
 */
export const getQuestionnaire = async (params: {
    examid?: string;
    questionnaireid?: string;
    section?: 'listening' | 'reading' | 'writing';
}): Promise<QuestionnaireResponse | null> => {
    try {
        const res = await api.get<TopikResponse<QuestionnaireResponse>>('/topik/questionnaire', {
            params,
            headers: {
                Authorization: `Bearer ${ss.getCurrentSession().jwt}`
            }
        });
        
        return res.data?.code === 200 ? (res.data.data ?? null) : null;
    } catch (e) {
        console.error('Failed to get questionnaire:', e);
        return null;
    }
};

/**
 * List user's allocated questionnaires
 * @param params Object with filtering and pagination options
 * @returns Promise with array of questionnaires
 */
export const listQuestionnaires = async (params?: {
    userid?: string;
    status?: string;
    limit?: number;
    offset?: number;
}): Promise<QuestionnaireType[] | null> => {
    try {
        const res = await api.get<TopikListResponse<QuestionnaireType>>('/topik/questionnaire', {
            params,
            headers: {
                Authorization: `Bearer ${ss.getCurrentSession().jwt}`
            }
        });
        
        return res.data?.code === 200 ? (res.data.data ?? []) : null;
    } catch (e) {
        if (e instanceof AxiosError && e.response?.data?.code === 404) {
            console.warn('No questionnaires found for the given parameters');
            return [];
        }

        console.error('Failed to list questionnaires:', e);
        return null;
    }
};